import PublicLayout from 'src/layout/PublicLayout';
import { LayoutPaper } from 'src/layout';
import RegisterForm from 'src/widgets/RegisterForm';
import CustomAccordion from 'src/components/CustomAccordion';
import { Box, Typography } from '@mui/material';

export default function Register() {
    return (
        <LayoutPaper>
            <PublicLayout>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                >
                    <RegisterForm />
                </Box>
            </PublicLayout>
        </LayoutPaper>
    );
}
